module.exports = __webpack_public_path__ + "img/draft.a3497d5b.png";